
import React from "react";
import Modal from "react-bootstrap/Modal";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "./GalleryModal.css"
import "swiper/css";
import "swiper/css/navigation";

const GalleryModal = ({ show, handleClose, images = [], IMG_URL }) => {
  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Gallery Images</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {images.length > 0 ? (
          <Swiper
            modules={[Navigation]}
            navigation={images.length > 1}
            slidesPerView={1}
            spaceBetween={10}
            className="gallery-swiper"
          >
            {images.map((img, index) => (
              <SwiperSlide key={index}>
                <div
                  style={{
                    width: "100%",
                    height: "500px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={IMG_URL + img}
                    alt={`gallery-${index}`}
                    style={{
                      maxWidth: "100%",
                      maxHeight: "500px",
                      objectFit: "contain",
                    }}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <p className="text-center m-0">No images available</p>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default GalleryModal;